import { InjectionToken } from '@angular/core';

import { environment } from '../../environments/environment';

export interface DroneTrackingOptions {
  apiBaseUrl: string;
  detectedDroneStaleAfterMs: number;
  defaultLookbackSeconds: number;
}

export const DEFAULT_DRONE_TRACKING_OPTIONS: Omit<DroneTrackingOptions, 'apiBaseUrl'> = {
  detectedDroneStaleAfterMs: 10000,
  defaultLookbackSeconds: 5,
};

export function createDroneTrackingOptions(): DroneTrackingOptions {
  return {
    ...DEFAULT_DRONE_TRACKING_OPTIONS,
    apiBaseUrl: environment.apiBaseUrl,
  };
}

export const DRONE_TRACKING_OPTIONS = new InjectionToken<DroneTrackingOptions>('DRONE_TRACKING_OPTIONS', {
  providedIn: 'root',
  factory: createDroneTrackingOptions,
});
